export const TAG_LOADING = "TAG_LOADING";
export const TAG_ERROR = "TAG_ERROR";

export const TAG_GET_LIST = "TAG_GET_LIST";
export const TAG_GET_LIST_NO_PAGINATION = "TAG_GET_LIST_NO_PAGINATION";
export const TAG_GET_FILTERS = "TAG_GET_FILTERS";
export const TAG_GET_SINGLE = "TAG_GET_SINGLE";
export const TAG_CREATE_TAG = "TAG_CREATE_TAG";
export const TAG_GET_TYPES = "TAG_GET_TYPES";



// WEBPACK FOOTER //
// ./src/actions/tag/constants.js